import React from "react";

const PriceContext = React.createContext(null);

export default PriceContext;
